import React from "react";

const TimeLimitContext = React.createContext({
    timeLimit: 60,
    setTimeLimit: () => {}
});

export default TimeLimitContext;
